module.exports = __webpack_public_path__ + "img/banner-champ2.7e2b4b38.png";